import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface MarketingToolsProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const MarketingTools = ({ variant }: MarketingToolsProps) => (
  <AffiliatesLink variant={variant} path="/marketing-tools/" category={'Marketing Tools'}>
    <I18n k="affiliates_signup_perseus.affiliates.marketing_tools" />
  </AffiliatesLink>
);
